module.exports = __webpack_public_path__ + "static/media/p2.1c840352.png";